import { useLiveQuery } from '@tanstack/react-db';
import { useMasterData } from '@/api/master-data/provider';
import type { UserWithTenantRole } from './models';

/**
 * Utente corrente nel tenant selezionato. Senza tenant (pagine pubbliche,
 * provider montati sopra il router) la query resta spenta e l'utente è
 * `null`: i permessi derivati valgono tutti `false`, senza lanciare.
 */
export function useUserMeLive() {
  const { userMe } = useMasterData();
  const result = useLiveQuery(
    (q) => (userMe ? q.from({ user: userMe }) : undefined),
    [userMe]
  );

  // Use isReady to determine loading state - isLoading alone can get stuck
  const isLoading = !result.isReady && !result.isError;

  // Return single user (first item) since this is a "me" endpoint
  return {
    ...result,
    data: (result.data?.[0] ?? null) as UserWithTenantRole | null,
    isLoading,
  };
}
